
const digest = 'c2e646a14ab354ed00457aa492e4d57b7532a017415d2abb9992c215aadbe70b';
const css = `:root {
  --checkbox-margin-right: var(--spacer-1);
  --checklist-text-margin-bottom: var(--spacer-05);
}

.aha-editor-v2 .aha-editor-v2__body {
  ul {
    list-style-type: disc;
    > li > ul {
      list-style-type: circle;
      > li > ul {
        list-style-type: square;
        > li > ul {
          list-style-type: disc;
        }
      }
    }
  }

  ol {
    > li > ol {
      list-style-type: lower-alpha;
      > li > ol {
        list-style-type: lower-roman;
        > li > ol {
          list-style-type: decimal;
        }
      }
    }
  }

  ul,
  ol {
    margin: 0 0 var(--default-type-margin) calc(var(--default-type-margin) * 2);
    padding: 0;

    ul,
    ol {
      margin-bottom: 0;
    }
  }
}

._ul-checklist_1awmf_44 {
  list-style: none;
}

._li-checkbox_1awmf_48 {
  margin-right: var(--checkbox-margin-right);
  list-style-type: none;

  ._checkbox-container_1awmf_52 {
    margin-left: -1.1rem;
    margin-right: 0.5rem;
  }

  input[type='checkbox'] {
    margin: 0;
  }

  p {
    margin: 0 0 var(--checklist-text-margin-bottom) 0;
  }

  > p {
    margin-left: 0.25rem;
  }
}

._li-checkbox_1awmf_48.h1-child ._checkbox-container_1awmf_52 {
  transform: translateY(-0.15em);
}
._li-checkbox_1awmf_48.h2-child ._checkbox-container_1awmf_52 {
  transform: translateY(-0.05em);
}
._li-checkbox_1awmf_48.h3-child ._checkbox-container_1awmf_52 {
  transform: translateY(0);
}
._li-checkbox_1awmf_48.h4-child ._checkbox-container_1awmf_52 {
  transform: translateY(0);
}
._li-checkbox_1awmf_48.h5-child ._checkbox-container_1awmf_52 {
  transform: translateY(0.05em);
}
._li-checkbox_1awmf_48.h6-child ._checkbox-container_1awmf_52 {
  transform: translateY(0.1em);
}

._li-checkbox_1awmf_48.paragraph-child, ._li-checkbox_1awmf_48.fontSize-child {
  ._checkbox-container_1awmf_52 {
    transform: translateY(calc(5.5px - 0.3em));
  }
}

._hide-marker_1awmf_95 {
  list-style-type: none;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"ulChecklist":"_ul-checklist_1awmf_44","liCheckbox":"_li-checkbox_1awmf_48","checkboxContainer":"_checkbox-container_1awmf_52","hideMarker":"_hide-marker_1awmf_95"};
export { css, digest };
  